import { NgComponentOutlet } from '@angular/common';
import { Component, computed, input, Signal } from '@angular/core';
import { BaseComponent } from '@shared/classes';
import { ExpireDate, ExpireDateDynamicComponent } from '@shared/models';

import { Variant1Component } from './variant1/variant1.component';
import { Variant2Component } from './variant2/variant2.component';

@Component({
  selector: 'b2c-expire-date',
  imports: [NgComponentOutlet],
  templateUrl: './expire-date.component.html',
})
export class ExpireDateComponent extends BaseComponent {
  campaignEndDate = input<string>('');
  campaignStartDate = input<string>('');

  public config: ExpireDate = this.loyaltyChallengeConfig.components.challenges
    .elements.expireDate as ExpireDate;

  public components: Signal<ExpireDateDynamicComponent<ExpireDate>> = computed(
    () => {
      return {
        [this.Variants.VARIANT_1]: {
          component: Variant1Component,
          inputs: {
            config: this.config,
            campaignEndDate: this.campaignEndDate(),
          },
        },
        [this.Variants.VARIANT_2]: {
          component: Variant2Component,
          inputs: {
            config: this.config,
            campaignEndDate: this.campaignEndDate(),
            campaignStartDate: this.campaignStartDate(),
          },
        },
      };
    }
  );
}
